import _ from 'lodash';

import {
  QueryAppleCareAgreementsFilterInput,
  useAppleCareAgreementsActivityLazyQuery
} from 'generated/graphql';
import {
  ApiRequestTable,
  routeDirectory
} from 'modules';

import { DateTime } from 'luxon';
import { listQueryUtil } from 'iron-forge-react-modules';
import * as types from './types';



const useListQuery = listQueryUtil.genUseListQuery<types.IColumnId>();



type IActivationStatus = 'pending' | 'activated' | 'error';

export interface IAppleCareAgreement {
  id: string;
  activatedAt: DateTime | null;
  orderDate: DateTime;
  agreementNumber: string;
  orderNumber: string;
  productName: string;
  serialNumber: string;
  sku: string;
  routeToOrderDetail: string;
  activationStatus: IActivationStatus;
  apiRequests: ApiRequestTable.IApiRequest[];
}

export interface IData {
  agreements: IAppleCareAgreement[];
}

export function useQuery() {
  return useListQuery({
    useLazyQuery: useAppleCareAgreementsActivityLazyQuery,
    clientColumn2GqlSortField: {
    },
    initQuerySort: {
      columnId: 'orderDate',
      direction: 'descending'
    },
    defaultFilterArgs: {},
    genFilter2GqlFilter: () => __formState2GqlFilter,
    gqlResultData2GqlPageInfo: gqlTuple => gqlTuple?.appleCareAgreements.pageInfo,
    gqlResultData2TupleData: (gqlTuple): IData => ({
      agreements: _.map(
        gqlTuple.data?.appleCareAgreements.nodes ?? [],
        (node): IAppleCareAgreement => ({
          id: node.id,
          sku: node.lineItem.product.sku,
          activatedAt: node.activatedAt ? DateTime.fromISO(node.activatedAt) : null,
          agreementNumber: node.agreementNumber,
          orderDate: DateTime.fromISO(node.lineItem.order.orderDate),
          orderNumber: node.lineItem.order.orderNumber,
          productName: node.lineItem.product.name,
          apiRequests: _.map(node.apiRequests.nodes ?? [], (node): ApiRequestTable.IApiRequest => ({
            id: node.id,
            metaCreated: DateTime.fromISO(node.metaCreated),
            method: node.method,
            isOK: false,
            requestBody: node.requestBody,
            responseBody: node.responseBody,
            statusCode: node.httpStatusCode,
            url: node.url
          })),
          routeToOrderDetail: routeDirectory.partner.storeDetail.path(
            node.lineItem.order.store.id,
            node.lineItem.order.id
          ),
          serialNumber: node.serialNumber,
          activationStatus: ((): IActivationStatus => {
            if (!_.isNil(node.activatedAt)) {
              return 'activated';
            } else if (!_.isEmpty(node.apiRequests.nodes)) {
              return 'error';
            } else {
              return 'pending';
            }
          })()
        }))
    })
  });
}



function __formState2GqlFilter(formState?: types.IFormState): QueryAppleCareAgreementsFilterInput {
  return {
    omniFreeText: formState?.omniFreeText ?? ''
  };
}
